import React from "react";
import { Box, Stack, TextField, Tooltip, Typography } from "@mui/material";

/**
 * "Vernostný systém" (Loyalty system) product tab content.
 *
 * Only mounted when the customer has the loyalty system enabled
 * (dsokSettings.settings.loyaltySystem.isEnabled). First setting: "Body" — the number of
 * loyalty points the customer earns for buying this product. Stored in
 * values.loyaltySystem.points and forwarded to the product API as loyaltySystem.points.
 *
 * Field help is shown on hover (MUI Tooltip + Box span wrapper), per project convention.
 */
const LoyaltySystemSection = ({ values, setFieldValue, t }) => {
  const points = values?.loyaltySystem?.points ?? "";

  const handleChange = (e) => {
    const raw = e.target.value;
    if (raw === "") {
      setFieldValue("loyaltySystem.points", "");
      return;
    }
    // Non-negative integer only.
    const n = Math.max(0, Math.trunc(Number(raw)));
    setFieldValue("loyaltySystem.points", Number.isFinite(n) ? n : "");
  };

  return (
    <Stack spacing={2} sx={{ maxWidth: 420 }}>
      <Typography variant="h5">
        {t("pages.dsokProducts.loyaltySystemTab.title", {
          defaultValue: "Vernostný systém",
        })}
      </Typography>

      <Tooltip
        arrow
        title={t("pages.dsokProducts.loyaltySystemTab.pointsHelp", {
          defaultValue:
            "Počet bodov, ktoré zákazník získa do vernostného systému pri kúpe tohto produktu.",
        })}
      >
        <Box component="span">
          <TextField
            fullWidth
            type="number"
            inputProps={{ min: 0, step: 1 }}
            label={t("pages.dsokProducts.loyaltySystemTab.points", {
              defaultValue: "Body",
            })}
            value={points}
            onChange={handleChange}
          />
        </Box>
      </Tooltip>
    </Stack>
  );
};

export default LoyaltySystemSection;
